import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/app-icon-1024.png';
import './Footer.css';

const Footer = () => {
  const socialLinks = [
    { icon: 'fab fa-twitter', href: '#', label: 'Twitter' },
    { icon: 'fab fa-linkedin', href: '#', label: 'LinkedIn' },
    { icon: 'fab fa-facebook', href: '#', label: 'Facebook' },
    { icon: 'fab fa-instagram', href: '#', label: 'Instagram' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-branding">
            <Link to="/" className="logo">
              <img src={logo} alt="LunarLog AI" className="logo-image" />
              <span className="logo-text">LunarLog AI</span>
            </Link>
            <p>
              The premier AI trading journal app.
            </p>
          </div>
          
          <div className="footer-legal">
            <a href="/Privacy Policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <span className="separator">•</span>
            <a href="/Terms and Conditions.pdf" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
          </div>
          
          <div className="social-links">
            {socialLinks.map((social, index) => (
              <a 
                key={index}
                href={social.href}
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className={social.icon}></i>
              </a>
            ))}
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 LunarLog AI LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
